import { CompletionRateData, FormSlug } from "../types";

export const areAllFormsComplete = (completionRateData: CompletionRateData) => {
  /**
   * The Content Promotion form should not be included in determining if all forms are complete.
   */
  const filteredCompletionRates = completionRateData?.completion_rates.filter(
    ({ form_slug: formSlug }) => formSlug !== FormSlug.ContentPromotion,
  );
  return filteredCompletionRates?.every(
    ({ completion_rate: completionRate }) => completionRate === 1,
  );
};
